export default __webpack_public_path__ + "static/media/dowload.0974addd.svg";